const promotionCodeStorageKey = 'promotion_code'
function removePromotionCode() {
  localStorage.removeItem(promotionCodeStorageKey)
}
function setPromotionCode(promotionCode) {
  localStorage.setItem(promotionCodeStorageKey, promotionCode)
}
function getPromotionCodeToLocalStore() {
  return localStorage.getItem(promotionCodeStorageKey)
}
export default {
  removePromotionCode,
  setPromotionCode,
  getPromotionCodeToLocalStore,
}
